import React, { useEffect, useState } from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/heart-rate-monitorapp.jpg';
import img_greenrapid from '../assets/images/img_greenrapid.png';
import img_hms from '../assets/images/img_hms.png';
import img_socotra from '../assets/images/img_socotra.png';
import img_firesafety from '../assets/images/img_firesafety.png';
import img_bankingapp from '../assets/images/img_bankingapp.png';
import img_palmstore from '../assets/images/img_plamstore.png';
import img_vpn from '../assets/images/img_vpn.png';
import img_hcm from '../assets/images/img_hcm.png';
import img_servicemate from '../assets/images/img_servicemate.png';
import img_locationfinder from '../assets/images/img_locationfiner.png';
import img_seieco from '../assets/images/img_seieco copy.png';
import mock08 from '../assets/images/carbillingapp.png';
import mock09 from '../assets/images/speedo7.png';
import mock10 from '../assets/images/hellosuperapp.png';
import '../assets/styles/Project.scss';
import { FiExternalLink } from "react-icons/fi";
import { trackProjectView, trackProjectClick, trackProjectTabFilter, trackSectionView } from '../utils/mixpanel';
import { SectionHeader } from './ui';
// Define project interface for TypeScript
interface ProjectData {
    id: number;
    image: string;
    title: string;
    description: string;
    link: string;
    category: "Android" | "iOS" | "Other";
    demoUrl?: string;
    caseStudyImages?: string[];
}

// Modal component for case study
interface CaseStudyModalProps {
    isOpen: boolean;
    onClose: () => void;
    project: ProjectData;
}

const CaseStudyModal: React.FC<CaseStudyModalProps> = ({ isOpen, onClose, project }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{project.title} - Case Study</h2>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <p>{project.description}</p>
                    
                    {/* Case study images gallery */}
                    <div className="case-study-gallery">
                        {project.caseStudyImages && project.caseStudyImages.length > 0 ? (
                            project.caseStudyImages.map((img, index) => (
                                <img key={index} src={img} alt={`${project.title} case study ${index + 1}`} />
                            ))
                        ) : (
                            <img src={project.image} alt={`${project.title} preview`} />
                        )}
                    </div>
                    
                    <div className="case-study-details">
                        <h3>Project Overview</h3>
                        <p>This {project.category} project demonstrates innovative solutions in the digital space.</p>
                        
                        <h3>Technologies Used</h3>
                        <ul>
                            {project.category === "Android" && <li>Java/Kotlin</li>}
                            {project.category === "iOS" && <li>Swift/SwiftUI</li>}
                            {project.category === "Other" && <li>React/JavaScript</li>}
                            <li>UI/UX Design Principles</li>
                            <li>Backend Integration</li>
                        </ul>
                        
                        <h3>Key Features</h3>
                        <ul>
                            <li>Intuitive user interface</li>
                            <li>Performance optimization</li>
                            <li>Cross-platform compatibility</li>
                        </ul>
                    </div>
                </div>
                <div className="modal-footer">
                    <a href={project.link} target="_blank" rel="noreferrer" className="modal-button primary">
                        Visit Project
                    </a>
                    {project.demoUrl && (
                        <a href={project.demoUrl} target="_blank" rel="noreferrer" className="modal-button secondary">
                            Watch Demo
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

// Video modal component
interface VideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    videoUrl: string;
}

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, onClose, videoUrl }) => {
    if (!isOpen) return null;

    const getYoutubeEmbedUrl = (url: string) => {
        const regExp = /(?:youtu\.be\/|youtube\.com\/(?:.*v=|.*\/embed\/|v\/|.*\/v\/|user\/.*#p\/u\/|shorts\/))([^#&?]*).*/;
        const match = url.match(regExp);
        const videoId = match && match[1]?.length === 11 ? match[1] : null;
        return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0` : url;
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Close Button (Only One) */}
                <button className="close-button" onClick={onClose}>
                    
                </button>

                {/* Video Container */}
                <div className="video-container">
                    <iframe 
                        src={getYoutubeEmbedUrl(videoUrl)}
                        title="Project Demo Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

function Project() {
    // State to track the active tab
    const [activeTab, setActiveTab] = useState<"All" | "Android" | "iOS" | "Other">("All");
    
    // State for active modals
    const [activeCaseStudy, setActiveCaseStudy] = useState<ProjectData | null>(null);
    const [activeVideo, setActiveVideo] = useState<string | null>(null);

    // Track section view when component mounts
    useEffect(() => {
        trackSectionView('projects');
    }, []);

    // Define project data with categories and additional info
    const projectsData: ProjectData[] = [
        {
            id: 1,
            image: mock10,
            title: "Hello Super App",
            description: "Hello Metpally Super APP is the ultimate all-in-one solution for your daily needs, tailored specifically to the local community. With a vast array of services at your fingertips, this native app revolutionizes convenience and accessibility.",
            link: "https://play.google.com/store/apps/details?id=com.app.metpallyapp",
            category: "Android",
            demoUrl: "",
            caseStudyImages: [mock10, mock02, mock03]
        },
        {
            id: 2,
            image: mock09,
            title: "Speedo7",
            description: "Speedo 7 provides restaurants with a simple solution to manage orders from various delivery services. Our platform combines all features to quickly handle and forward orders to drivers.",
            link: "https://speedo7.de/",
            category: "Other",
            demoUrl: "",
            caseStudyImages: [mock09, mock02]
        },
        // Add demo URLs and case study images for all other projects
        {
            id: 3,
            image: mock08,
            title: "Car Billing App",
            description: "A comprehensive billing application designed specifically for electric and hybrid vehicles, providing seamless management of charging costs, invoicing, and payment tracking for both personal and fleet use.",
            link: "https://apps.apple.com/de/app/it-4ecar/id1604357558",
            category: "iOS",
            demoUrl: ""
        },
        // {
        //     id: 4,
        //     image: mock07,
        //     title: "Heart Rate Monitor",
        //     description: "Track your heart rate and stay on top of your fitness goals. Heart Rate Monitor provides accurate, real-time health insights to help you maintain a healthy lifestyle and keep an eye on your overall well-being.",
        //     link: "https://play.google.com/store/apps/details?id=com.workoutapps.heart.rate.monitor&hl=en_US&gl=US",
        //     category: "Android",
        //     demoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        // },
        // {
        //     id: 5,
        //     image: mock06,
        //     title: "Voice Personality Analysis App",
        //     description: "This mobile application allows realtors in Japan to securely manage their property information and view future income predictions. This app is built with Ruby on Rails and JavaScript.",
        //     link: "http://www.wemanage.jp/",
        //     category: "iOS",
        //     demoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        // },
        // {
        //     id: 6,
        //     image: mock05,
        //     title: "Document Scanner App",
        //     description: "Built official charts for COVID/vaccination tracking for an educational institution using JavaScript and the Google Sheets API v4. The dashboard served the university's leadership in their decision-making processes.",
        //     link: "https://www.byuh.edu/covid-19-case-management",
        //     category: "Other",
        //     demoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        // },
       
        {
            id: 8,
            image: img_locationfinder,
            title: "Where is",
            description: "Where is helps users easily locate essential spots like ATMs, dustbins, toilets, and more. Our app provides a seamless way to find nearby facilities, ensuring convenience and efficiency wherever you go.",
            link: "",
            category: "Android",
           
        },
        {
            id: 11,
            image: img_palmstore,
            title: "Palm Store",
            description: "An online shopping app offering a seamless experience for purchasing premium dates with secure payments and swift delivery.",
            link: "",
            category: "Android"
        },
        {
            id: 9,
            image: img_bankingapp,
            title: "BCP App",
            description: "Created an interactive CSV table generator with Java, Handlebars, and LESS. This project helps transfer students to quickly identify eligible credits.",
            link: "",
            category: "Android"
        },
        {
            id: 10,
            image: img_socotra,
            title: "Socotra Island App",
            description: "Discover the enchanting beauty of Socotra Island with an immersive exploration app designed to guide you through its unique landscapes, flora, and fauna.",
            link: "",
            category: "iOS",
           
        },
        
        {
            id: 12,
            image: img_vpn,
            title: "Vpn Pro",
            description: "VPN Pro is your ultimate solution for secure, private, and unrestricted internet access. Whether you’re looking to protect your online privacy, bypass geo-restrictions, or secure your connection on public Wi-Fi, VPN Pro has got you covered.",
            link: "",
            category: "Android"
        },
        {
            id: 13,
            image: img_firesafety,
            title: "Fire Safety App",
            description: "The fire safety application is engineered to facilitate thorough inspections and streamline the procurement of fire safety equipment, ensuring both comprehensive evaluation and efficient acquisition of necessary products.",
            link: "",
            category: "Android"
        },

        {
            id: 16,
            image: img_greenrapid,
            title: "Green Rapid",
            description: "GreenRapid offers businesses a seamless solution for managing logistics efficiently. Our platform integrates all essential features to streamline shipments, track deliveries, and optimize routes for faster and more reliable transportation.",
            link: "https://greenrapid.de/",
            category: "Other",
            demoUrl: ""
        },
        {
            id: 14,
            image: img_hms,
            title: "Hospital Management System",
            description: "Smarter HMS eHospital System is a hospital management system software designed to manage all aspects of a hospital operation.",
            link: "",
            category: "Other",
           
        },
        {
            id: 15,
            image: img_hcm,
            title: "Human Capital Management",
            description: "HCM software is a comprehensive solution designed to manage an organization’s workforce.HCM software helps improve efficiency and enhances employee engagement by centralizing data and automating tasks.",
            link: "",
            category: "Other",
           
        },
       
        // {
        //     id: 17,
        //     image: mock01,
        //     title: "Smart Ambulance",
        //     description: "Developed and released an Android mobile application using Java and Android Studio that runs a 2D shooting game.",
        //     link: "https://github.com/yujisatojr/submeowrine",
        //     category: "Android"
        // },
        // {
        //     id: 18,
        //     image: img_seieco,
        //     title: "SeiEco App",
        //     description: "SeiECO app is your go-to companion for a sustainable digital life.Simplify eco-friendly living with smart, green choices every day.",
        //     link: "https://github.com/yujisatojr/submeowrine",
        //     category: "iOS"
        // },
        // {
        //     id: 7,
        //     image: img_servicemate,
        //     title: "Service Mate",
        //     description: "Analyzed the real estate market in Japan and predicted property prices by implementing statistical methods such as OLS and multi-regression analysis. This project leveraged Python and various libraries such as Pandas, NumPy, Matplotlib, and Scikit-Learn.",
        //     link: "https://github.com/yujisatojr/multi-reg-analysis",
        //     category: "Android",
        //     demoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        // },
    ];

    // Function to filter projects based on active tab
    const filteredProjects = activeTab === "All" 
        ? projectsData 
        : projectsData.filter(project => project.category === activeTab);

    // Handle tab change with tracking
    const handleTabChange = (tab: "All" | "Android" | "iOS" | "Other") => {
        setActiveTab(tab);
        trackProjectTabFilter(tab);
    };

    // Open case study modal
    const openCaseStudy = (project: ProjectData) => {
        setActiveCaseStudy(project);
        trackProjectView(project.title, project.category);
    };

    const showProject = (url: string, projectTitle: string, projectCategory: string) => {
        window.open(url, "_blank"); // Opens in a new tab
        trackProjectClick(projectTitle, projectCategory, url);
    };

    // Open video modal
    const openVideo = (url: string) => {
        setActiveVideo(url);
    };

    // Prevent User for download images by right click or drag
    useEffect(() => {
        const disableRightClick = (event: MouseEvent): void => {
          event.preventDefault();
        };
    
        const disableDragDownload = (event: DragEvent): void => {
          event.preventDefault();
        };
    
        // Disable right-click context menu
        document.addEventListener("contextmenu", disableRightClick);
    
        // Disable drag-to-download
        document.addEventListener("dragstart", disableDragDownload);
    
        // Cleanup event listeners on component unmount
        return () => {
          document.removeEventListener("contextmenu", disableRightClick);
          document.removeEventListener("dragstart", disableDragDownload);
        };
    }, []);

    return(
        <section className="projects-section" id="projects">
          <div className="projects-section__container">
            <SectionHeader title="Projects" align="left" />

            {/* Tabs navigation */}
            <div className="projects-tabs">
                {["All", "Android", "iOS", "Other"].map((tab) => (
                    <button
                        key={tab}
                        className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => handleTabChange(tab as "All" | "Android" | "iOS" | "Other")}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className="projects-grid">
                {filteredProjects.map((project) => (
                    <div
                        className="project-card"
                        key={project.id}
                        onMouseEnter={() => trackProjectView(project.title, project.category)}
                    >
                        <div className="project-card__image-wrap">
                            <img src={project.image} className="project-card__img" alt={project.title} />

                            {/* Category Badge */}
                            <span className={`project-card__badge project-card__badge--${project.category.toLowerCase()}`}>
                                {project.category}
                            </span>

                            {/* Hover overlay */}
                            {project.link && (
                                <div className="project-card__overlay">
                                    <a
                                        href={project.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="project-card__view-btn"
                                        onClick={() => trackProjectClick(project.title, project.category, project.link)}
                                    >
                                        <FiExternalLink />
                                        View Project
                                    </a>
                                </div>
                            )}
                        </div>

                        <div className="project-card__body">
                            <h3 className="project-card__title">{project.title}</h3>
                            <p className="project-card__desc">{project.description}</p>
                        </div>
                    </div>
                ))}
            </div>
          </div>

          {/* Case Study Modal */}
          {activeCaseStudy && (
              <CaseStudyModal
                  isOpen={activeCaseStudy !== null}
                  onClose={() => setActiveCaseStudy(null)}
                  project={activeCaseStudy}
              />
          )}

          {/* Video Modal */}
          {activeVideo && (
              <VideoModal
                  isOpen={activeVideo !== null}
                  onClose={() => setActiveVideo(null)}
                  videoUrl={activeVideo}
              />
          )}
        </section>
    );
}

export default Project;